module.exports = __webpack_public_path__ + "3efd22502c9c7bc930febec4e39fa910.svg";